import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { getSamplingQueries, OrderPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/orders_/$id')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.WipPages);
  },
  loader: async ({ context, params }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.orders.detail(Number(params.id)),
    );
  },
  component: OrderPage,
});
